AOS.init(
  {
    once: true,
  }
);

document.addEventListener("DOMContentLoaded", function () {

  const video = document.getElementById('videoSecMn');
  const toggleBtn = document.getElementById('toggleBtn');
  const videoWrapper = document.querySelector('.video-banner-hldr');
  const videoContentBox = document.getElementById('videoContentBox');

  const playIcon = `
  <svg width="18" height="18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 2v12l10-6-10-6z"/>
  </svg> Play Video
`;

  const pauseIcon = `
  <svg width="18" height="18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 2h3v12H6zm5 0h3v12h-3z"/>
  </svg> Pause Video
`;

  videoContentBox.addEventListener('click', () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  video.addEventListener('play', () => {
    toggleBtn.innerHTML = pauseIcon;
    video.controls = true;
    videoWrapper.classList.add('video-playing');
  });

  video.addEventListener('pause', () => {
    toggleBtn.innerHTML = playIcon;
    video.controls = false;
    videoWrapper.classList.remove('video-playing');
  });

  video.addEventListener('ended', () => {
    toggleBtn.innerHTML = playIcon;
    video.controls = false;
    videoWrapper.classList.remove('video-playing');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function faqsAccordion() {
    var accordionSections = document.querySelectorAll(".accordion-item");

    if (accordionSections.length > 0) {
      // Set first item as active and open
      var firstAccordionItemHeader = accordionSections[0].querySelector(
        ".accordion-item-header"
      );
      var firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

      if (firstAccordionItemBody) {
        firstAccordionItemHeader.classList.add("active");
        firstAccordionItemBody.style.maxHeight =
          firstAccordionItemBody.scrollHeight + "px";
      }

      // Set all other items as inactive and closed
      for (let i = 1; i < accordionSections.length; i++) {
        var otherHeader = accordionSections[i].querySelector(".accordion-item-header");
        var otherBody = otherHeader.nextElementSibling;

        if (otherBody) {
          otherHeader.classList.remove("active");
          otherBody.style.maxHeight = "0";
        }
      }
    }

    accordionSections.forEach((section) => {
      var accordionItemHeaders = section.querySelector(".accordion-item-header");
      var accordionItemBody = section.querySelector(".accordion-item-body");

      accordionItemHeaders.addEventListener("click", function () {
        var currentlyActiveHeader = document.querySelector(
          ".accordion-item-header.active"
        );
        var currentlyActiveBody = currentlyActiveHeader
          ? currentlyActiveHeader.nextElementSibling
          : null;

        if (currentlyActiveHeader && currentlyActiveBody) {
          currentlyActiveHeader.classList.remove("active");
          currentlyActiveBody.style.maxHeight = 0;
        }

        if (accordionItemHeaders !== currentlyActiveHeader) {
          accordionItemHeaders.classList.add("active");
          accordionItemBody.style.maxHeight =
            accordionItemBody.scrollHeight + "px";
        } else {
          accordionItemHeaders.classList.remove("active");
          accordionItemBody.style.maxHeight = 0;
        }
      });
    });
  }

  faqsAccordion();
});

document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.tabProd');
  const contents = document.querySelectorAll('.tab-prod-content');
  tabs[0].classList.add('active-tab');
  contents[0].classList.add('active-content');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active-tab'));
      contents.forEach(c => c.classList.remove('active-content'));

      tab.classList.add('active-tab');
      contents[index].classList.add('active-content');
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const contentBoxes = document.querySelectorAll(".testiCntTop");

  contentBoxes.forEach(function (contentBox) {
    const para = contentBox.querySelector("p");
    requestAnimationFrame(() => {
      const isClamped = para.scrollHeight > para.clientHeight;
      if (isClamped) {
        const toggleBtn = document.createElement("span");
        toggleBtn.className = "read-toggle";
        toggleBtn.textContent = "Read More";

        contentBox.appendChild(toggleBtn);

        toggleBtn.addEventListener("click", function () {
          contentBox.classList.toggle("expanded");
          toggleBtn.textContent = contentBox.classList.contains("expanded")
            ? "Read Less"
            : "Read More";
        });
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const openPopupBtn = document.getElementById("popup-product-open-btn");
  const popup = document.getElementById("popup-product");
  const closePopupBtn = document.getElementById("popup-product-close-btn");
  
  openPopupBtn.onclick = function() {
    popup.style.display = "flex";
    popup.classList.add("active"); 
    popup.style.animation = "none";
    setTimeout(() => {
      popup.style.animation = "fadeIn 0.5s forwards";
    }, 10); 
  }
  
  closePopupBtn.onclick = function() {
    popup.style.display = "none";
    popup.classList.remove("active");
  }
  
  window.onclick = function(event) {
    if (event.target == popup) {
      popup.style.display = "none";
      popup.classList.remove("active"); 
    }
  }
});


// {
//   document.addEventListener("DOMContentLoaded", function () {
//     const timer = document.querySelector(".timer_line");
//     const dateAttr = timer.getAttribute("data-date");
//     const targetDate = new Date(dateAttr + "T00:00:00").getTime();

//     const daysEl = timer.querySelector(".days");
//     const hoursEl = timer.querySelector(".hours");
//     const minutesEl = timer.querySelector(".minutes");
//     const secondsEl = timer.querySelector(".seconds");

//     function updateTimer() {
//       const now = new Date().getTime();
//       const distance = targetDate - now;

//       if (distance <= 0) {
//         daysEl.textContent = "00";
//         hoursEl.textContent = "00";
//         minutesEl.textContent = "00";
//         secondsEl.textContent = "00";
//         clearInterval(timerInterval);
//         return;
//       }

//       const days = Math.floor(distance / (1000 * 60 * 60 * 24));
//       const hours = Math.floor(
//         (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
//       );
//       const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       const seconds = Math.floor((distance % (1000 * 60)) / 1000);

//       daysEl.textContent = String(days).padStart(2, "0");
//       hoursEl.textContent = String(hours).padStart(2, "0");
//       minutesEl.textContent = String(minutes).padStart(2, "0");
//       secondsEl.textContent = String(seconds).padStart(2, "0");
//     }

//     updateTimer();
//     const timerInterval = setInterval(updateTimer, 1000);
//   });
// }